//// Testimonial Slider
var swiperTesti = new Swiper(".testimonialSlider", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
    clickable: true,
  },
  navigation: {
    nextEl: ".testimonialSlider_navigation .button-next",
    prevEl: ".testimonialSlider_navigation .button-prev",
  },
  breakpoints: {
    600: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    1250: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  }
});
/////////////////////

//// Link Boxes Section SLider For Mobile 
let swiperLinkBoxes = null;

function initializeSwiper() {
  swiperLinkBoxes = new Swiper(".LinkBoxes", {
    slidesPerView: 2,
    spaceBetween: 20,
    breakpoints: {
      750: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    }
  });
}

function destroySwiper() {
  if (swiperLinkBoxes !== null) {
    swiperLinkBoxes.destroy(true, true);
    swiperLinkBoxes = null;
  }
}

function checkScreenSize() {
  if (window.innerWidth < 1250 && swiperLinkBoxes === null) {
    initializeSwiper();
  } else if (window.innerWidth >= 1250 && swiperLinkBoxes !== null) {
    destroySwiper();
  }
}

// Initial check
checkScreenSize();

// Add the resize event listener
window.addEventListener('resize', function () {
  checkScreenSize();
});

/////////////////////

//// Logo Slider Section
var swiperLogos = new Swiper(".logoSlider", {
  slidesPerView: 2,
  spaceBetween: 20,
  loop: true,
  autoplay: {
    delay: 3000,
  },
  breakpoints: {
    600: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
    1250: {
      slidesPerView: 6,
      spaceBetween: 30,
    },
  },
  navigation: {
    nextEl: ".logoSlider_navigation .button-next",
    prevEl: ".logoSlider_navigation .button-prev",
  },
});
/////////////////////

//// Recently Viewed Products Slider
var swiperRecentProd = new Swiper(".recently-viewedSlider", {
  slidesPerView: 2,
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: ".recently-viewed_navigation .button-next",
    prevEl: ".recently-viewed_navigation .button-prev",
  },
  breakpoints: {
    600: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    1250: {
      slidesPerView: 5,
      spaceBetween: 10,
    },
  }
});
/////////////////////

//// Collection List Section Slider
var swiperColList = new Swiper(".CollectionsList_Slider", {
  slidesPerView: 2,
  spaceBetween: 15,
  loop: true,
  navigation: {
    nextEl: ".CollectionsList_navigation .button-next",
    prevEl: ".CollectionsList_navigation .button-prev",
  },
  breakpoints: {
    600: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
    750: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 15,
    },
    1250: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
  }
});
/////////////////////

//// Related Collections Slider
var swiperRelatedCol = new Swiper(".RelatedCollections", {
  slidesPerView: 2,
  spaceBetween: 15,
  loop: true,
  navigation: {
    nextEl: ".RelatedCollections_navigation .button-next",
    prevEl: ".RelatedCollections_navigation .button-prev",
  },
  breakpoints: {
    600: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
    750: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 15,
    },
    1250: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
  }
});
/////////////////////

//// Product Suggestion Section by Sobooster Slider
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    const scrollContainer = document.querySelector('.prod-sugg ul.product-grid');
    const scrollLeftBtn = document.getElementById('snap_prev');
    const scrollRightBtn = document.getElementById('snap_next');
    const scrollAmount = window.innerWidth < 768 ? 150 : 300;

    function updateButtonState() {
      if (scrollContainer.scrollLeft === 0) {
        scrollLeftBtn.classList.add('disabled');
      } else {
        scrollLeftBtn.classList.remove('disabled');
      }

      if (scrollContainer.scrollLeft + scrollContainer.clientWidth - 10 >= scrollContainer.scrollWidth) {
        scrollRightBtn.classList.add('disabled');
      } else {
        scrollRightBtn.classList.remove('disabled');
      }
    }

    if (scrollContainer && scrollLeftBtn && scrollRightBtn) {
      scrollLeftBtn.addEventListener('click', () => {
        scrollContainer.scrollLeft -= scrollAmount;
        updateButtonState();
      });

      scrollRightBtn.addEventListener('click', () => {
        scrollContainer.scrollLeft += scrollAmount;
        updateButtonState();
      });

      window.addEventListener('resize', () => {
        scrollAmount = window.innerWidth < 768 ? 150 : 300;
        updateButtonState();
      });

      updateButtonState();

      scrollContainer.addEventListener('scroll', updateButtonState);
    }
  }, 2000);
});
/////////////////////

///// Product Gallery
// Slider Initialize
var swiperProdGallery = new Swiper(".ProductMedia_gallery-wrapper", {
  slidesPerView: 1,
  spaceBetween: 10,
  // loop: true,
  breakpoints: {
    1250: {
      slidesPerView: 2,
      spaceBetween: 5,
    },
  },
  navigation: {
    nextEl: ".prod_navigation .button-next",
    prevEl: ".prod_navigation .button-prev",
  },
});
// Function to jump to the specific slide based on selected variant
function jumpToVariantSlide(mediaId) {
  const targetSlideIndex = [...document.querySelectorAll('.ProductMedia_gallery-wrapper .swiper-slide')].findIndex(slide => slide.getAttribute('data-media') === mediaId);

  if (targetSlideIndex !== -1) {
    swiperProdGallery.slideTo(targetSlideIndex);
  }
}

document.querySelectorAll('.product-form__input input[type="radio"][name="Color"]').forEach(radio => {
  radio.addEventListener('change', function () {
    const selectedMediaId = this.nextElementSibling.getAttribute('data-media');
    jumpToVariantSlide(selectedMediaId);

    // Select first available size variant when switching color
    setTimeout(() => {
      const sizeSelects = document.querySelectorAll('[variant-type="Size"] input[type="radio"]:not(.disabled)');
      const firstAvailableSize = sizeSelects[0];

      if (firstAvailableSize) {
        const label = firstAvailableSize.nextElementSibling;
        label.click();
        console.log('Clicked option, first available size selected:', firstAvailableSize.value);
      } else {
        console.log('No available sizes found for this color.');
      }
    }, 500);
  });
});
// Video Play/Pause
function toggleMainVideo() {
  const video = document.getElementById('ProductMedia_MainVideo');
  const buttonPlay = document.getElementById('buttonPlay');
  if (video.paused) {
    video.play();
    buttonPlay.classList.remove('paused');
  } else {
    video.pause();
    buttonPlay.classList.add('paused');
  }
}
/////////////////////

//// Open Modal Box In Header Top Bar
let topbarItems = document.querySelectorAll('.topbar-item');
let openPopupAnchors = document.querySelectorAll('.open_popup');

function openModal(modalOverlay, modalBox) {
  modalOverlay.classList.add('active');
  modalBox.classList.add('active');
}

topbarItems.forEach(function (topbarItem) {
  let modalPopup = topbarItem.querySelector('.modal-popup');
  let modalOverlay = topbarItem.querySelector('.modalbox-overlay');
  let modalBox = topbarItem.querySelector('.modalbox');
  let closeModalButton = topbarItem.querySelector('.modal__close');
  let modalOVerlay = topbarItem.querySelector('.modalbox-overlay');

  if (modalPopup && modalOverlay && modalBox && closeModalButton) {
    modalPopup.addEventListener('click', function (event) {
      event.preventDefault();
      openModal(modalOverlay, modalBox);
    });

    closeModalButton.addEventListener('click', function () {
      modalOverlay.classList.remove('active');
      modalBox.classList.remove('active');
    });
    modalOVerlay.addEventListener('click', function () {
      modalOverlay.classList.remove('active');
      modalBox.classList.remove('active');
    });
  }
});

openPopupAnchors.forEach(function (openPopupAnchor) {
  openPopupAnchor.addEventListener('click', function (event) {
    event.preventDefault();
    let modalOverlay = document.querySelector('.modalbox-overlay');
    let modalBox = document.querySelector('.modalbox');
    openModal(modalOverlay, modalBox);
  });
});
/////////////////////

// //// Header MegaMenu Open on Hover
// const menuItems = document.querySelectorAll('.HeaderMenu_item');

// menuItems.forEach((menuItem, index) => {
//   const contentDiv = document.getElementById(`MegaMenu-Content-${index + 1}`);

//   menuItem.addEventListener('mouseover', () => {
//     contentDiv.style.height = `${contentDiv.scrollHeight}px`;
//     contentDiv.classList.add('active');
//   });

//   menuItem.addEventListener('mouseout', () => {
//     contentDiv.style.height = '0';
//     contentDiv.classList.remove('active');
//   });
// });
// /////////////////////

//// remove spaces in product description
document.addEventListener('DOMContentLoaded', function () {
  const productDescription = document.querySelector(".product__info-wrapper .product_description");

  if (productDescription) {
    // Replace all &nbsp; with a regular space within the product description div
    productDescription.innerHTML = productDescription.innerHTML.replace(/&nbsp;/g, ' ');
  }
});
/////////////////////


//// Product Card Swatches Show/Hide
document.querySelectorAll('.number-showmore').forEach(function (anchor) {
  anchor.addEventListener('click', function (event) {
    event.preventDefault(); // Prevent default anchor behavior
    const fieldset = anchor.closest('fieldset');
    if (fieldset) { // Check if fieldset exists
      fieldset.classList.toggle('show_more');
    }
  });
});

/////////////////////

//// Product Card Swatchers
var productCards = document.querySelectorAll('.product-card-wrapper');

productCards.forEach(function (card) {
  // Get all the li elements inside the .variant-selects of the current card
  var variantItems = card.querySelectorAll('.variant-selects li');

  variantItems.forEach(function (item) {
    item.addEventListener('click', function () {
      // Remove the 'selected' class from all li elements in the current card
      variantItems.forEach(function (variant) {
        variant.classList.remove('selected');
      });

      // Get the data-img attribute from the clicked li element
      var newImgUrl = item.getAttribute('data-img');
      item.classList.add('selected');  // Add the 'selected' class to the clicked item

      // Find the main image inside the same parent card
      var mainImage = card.querySelector('.card__media img');
      var pictureElement = card.querySelector('.card__media picture');
      var sourceElements = pictureElement.querySelectorAll('source');

      // Create and show the loader
      var loader = document.createElement('div');
      loader.className = 'image-loader'; // You can style this class in CSS
      card.querySelector('.card__media').appendChild(loader);

      // Update the image src
      var newImageSrc = '//wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?width=364';
      var newImageSrcset = '//www.wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602&width=165 165w,//www.wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602&width=360 360w,//www.wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602&width=533 533w,//www.wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602&width=720 720w,//www.wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602&width=940 940w,//www.wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602&width=1066 1066w,//www.wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?v=1722945602 3008w';

      // Define new srcset values for the source elements
      var newSrcSets = {
        '(min-width: 1066px)': '//www.wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?&width=1066',
        '(min-width: 940px)': '//www.wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?&width=940',
        '(min-width: 720px)': '//www.wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?&width=720',
        '(min-width: 533px)': '//www.wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?&width=533',
        '(min-width: 360px)': '//www.wholesaledressoutlet.com/cdn/shop/' + newImgUrl + '?&width=360'
      };

      // Preload the new image
      var img = new Image();
      img.src = newImageSrc;
      img.srcset = newImageSrcset;

      // When the image has loaded, replace the src of the main image and hide the loader
      img.onload = function () {
        mainImage.src = newImageSrc;
        mainImage.srcset = newImageSrcset;

        // Update each source element's srcset
        sourceElements.forEach(function (source) {
          var mediaSource = source.getAttribute('media');
          if (newSrcSets[mediaSource]) {
            source.srcset = newSrcSets[mediaSource];
          }
        });

        // Remove the loader
        loader.remove();
      };

      // Optionally handle image load errors
      img.onerror = function () {
        console.error('Image failed to load:', newImageSrc);
        loader.remove(); // Remove the loader even if the image fails to load
      };
    });
  });
});
/////////////////////

////// Changing Image and link for variants of new split products
document.addEventListener('click', function (e) {
  if (e.target.closest('.product-grid li .color-swatch_wrapper a')) {
    e.preventDefault();

    // Get the clicked anchor element
    var anchor = e.target.closest('a');

    // Get the parent product card (li element) of the clicked anchor
    var parentProductCard = anchor.closest('.product-grid li');

    // Remove the active class from all color swatches within the clicked product card
    var colorSwatchesInCard = parentProductCard.querySelectorAll('.color-swatch_wrapper a');
    colorSwatchesInCard.forEach(function (swatch) {
      swatch.classList.remove('ss-border-black');
    });

    // Add the active class to the clicked color swatch
    anchor.classList.add('ss-border-black');

    // Get the link and big image source
    var link = anchor.getAttribute('href');
    var imageBig = anchor.querySelector('img').getAttribute('data-src');

    // Get the slider slide wrapper
    var obj = anchor.closest('.grid__item');

    // Update the main product image source in <img> inside <picture>
    var mainImage = obj.querySelector('.card__media img');
    if (mainImage) {
      // mainImage.setAttribute('src', imageBig);
      if (mainImage.hasAttribute('srcset')) {
        mainImage.setAttribute('src', imageBig);
        mainImage.setAttribute('srcset', imageBig);
      } else {
        mainImage.setAttribute('src', imageBig);
      }
    }

    // Update the <source> elements inside the <picture> tag with the new image
    var sources = obj.querySelectorAll('.card__media picture source');
    sources.forEach(function (source) {
      source.setAttribute('srcset', imageBig);  // Replace with the new image URL
    });

    // Update the href attribute of the clicked anchor
    //anchor.setAttribute('href', link);
    var infoLink = obj.querySelector('.card--media .card__inner + .card__content .card__information .card__heading  a');
    if (infoLink) {
      infoLink.setAttribute('href', link);
    }
  }
});

///// Removing cart popup noti after 2.5s
document.addEventListener('DOMContentLoaded', function () {
  // Select the target node (the cart notification element)
  var cartNotification = document.getElementById('cart-notification');

  if (cartNotification) {
    // Create an observer instance to watch for changes in the 'class' attribute
    var observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (mutation.attributeName === 'class') {
          // Check if the 'active' class was added
          if (cartNotification.classList.contains('active')) {
            setTimeout(function () {
              // Find the close button inside the cart notification
              var closeButton = cartNotification.querySelector('.cart-notification__close.modal__close-button');

              // If the close button exists, trigger a click on it
              if (closeButton) {
                closeButton.click();
              }
            }, 2500);
          }
        }
      });
    });

    // Configure the observer to watch for attribute changes on the cart notification
    observer.observe(cartNotification, { attributes: true });
  }
});
/////////////////////////

